<template></template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Account/ForgotPassword.vue